export const columns = [
  {
    title: "序号",
    width: "50px",
    customRender: ({ index }) => index + 1,
  },
  {
    title: "平台",
    width: "110px",
    slots: { customRender: "platform" },
  },
  {
    title: "店铺ID",
    width: "200px",
    dataIndex: "ShopId",
  },
  {
    title: "店铺名称",
    width: "300px",
    slots: { customRender: "shopName" },
  },
  {
    title: "应用",
    width: "200px",
    slots: { customRender: "appName" },
  },
  {
    title: "应用过期时间",
    width: "220px",
    slots: { customRender: "appExpiresIn" },
  },
  {
    title: "是否能邀请",
    slots: { customRender: "canInvite" },
    isMustMultiMall: true,
  },
  {
    title: "是否能看其他店铺订单",
    slots: { customRender: "canSearchOrder" },
    isMustMultiMall: true,
  },
  {
    title: "操作",
    slots: { customRender: "operate" },
  },
];
